import appConfig from './index';
import { loaders, owners, dependencies, screens } from './deferred/manifest';

const loaded = new Set();
const pending = new Map();

function loadGroup(group) {
    if (loaded.has(group) || !loaders[group]) return Promise.resolve();
    if (pending.has(group)) return pending.get(group);
    const request = loaders[group]().then((module) => {
        for (const [category, entries] of Object.entries(module.default)) appConfig[category].push(...entries);
        loaded.add(group);
    }).finally(() => pending.delete(group));
    pending.set(group, request);
    return request;
}

export function ensureConfigTables(names) {
    if (names === '*') return Promise.all(Object.keys(loaders).map(loadGroup));
    const visited = new Set();
    const visit = (name) => {
        if (visited.has(name)) return;
        visited.add(name);
        (dependencies[name] || []).forEach(visit);
    };
    (names || []).forEach(visit);
    return Promise.all(Array.from(new Set(Array.from(visited).map((name) => owners[name]).filter(Boolean))).map(loadGroup));
}

export function ensureScreenConfig(key) {
    // A newly added or dynamically configured screen must never render with
    // missing metadata. Regenerate the manifest to regain granular loading.
    return ensureConfigTables(screens[key] || '*');
}

export function ensureBootstrapConfig() {
    // Authentication, setup, shared shell and pickers can mount outside routes.
    return ensureConfigTables(Object.keys(owners).filter((name) =>
        ['shared', 'sys', 'user', 'org', 'entity', 'item', 'wf'].includes(owners[name])));
}

// Config consumers keep mutable per-table caches. Reload on metadata HMR rather
// than retaining old field definitions alongside a freshly generated registry.
if (module.hot) module.hot.decline();
